import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Column, Row } from 'further-ui/components/Layout';
import { PropsWithChildren, useState } from 'react';
import { numberToCurrencyString } from 'further-ui/utils';
import { CurrencyCode } from 'further-types/lp/vehicle';
import ButtonBase from '@mui/material/ButtonBase';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

type Props = {
  currencyLcy?: CurrencyCode;
  title: string;
  value: number;
};

const OverviewRow: React.FC<PropsWithChildren<Props>> = ({
  title,
  value,
  currencyLcy,
  children,
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Column spacing="sm">
      <Row justify="space-between">
        <Row centered spacing="xxs">
          <Typography variant="h6">{title}</Typography>
          {children ? (
            <ButtonBase onClick={() => setExpanded((prev) => !prev)}>
              {expanded ? (
                <ExpandLess fontSize="small" />
              ) : (
                <ExpandMore fontSize="small" />
              )}
            </ButtonBase>
          ) : null}
        </Row>
        <Typography variant="h6">
          {numberToCurrencyString(value, { currency: currencyLcy })}
        </Typography>
      </Row>
      {expanded ? children : null}
      <Divider />
    </Column>
  );
};

export default OverviewRow;
